import { css } from '@emotion/css'
import { spacing, fontWeight } from '@offerzen/pinata-shame'

const styles = {
  card: css({
    textAlign: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    padding: spacing.extraLarge,

    '& > * + *': {
      marginTop: spacing.default,
    },

    '& > img': {
      marginBottom: spacing.small,
    },

    '& > h1': {
      fontWeight: fontWeight.bold,
    },
  }),
}

export default styles
